import { render, staticRenderFns } from "./DeactivateTemplatePopup.vue?vue&type=template&id=d6b30154&"
import script from "./DeactivateTemplatePopup.vue?vue&type=script&lang=js&"
export * from "./DeactivateTemplatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports